/* eslint-disable no-unused-vars */
import React from "react";
import { Button, Form, message, Select, Spin } from "antd";
import "antd/dist/antd.css";
import API from "../../../api";
import urls from "../../../api/urls";

const CompanySelection = ({
  companies,
  handleRedirectDashboard,
  setSelectedCompany,
  loading,
}) => {
  const { SHOW_RETAIL_ID_QA, SHOW_RETAIL_ID_PROD } = urls;

  const currentEnv = process.env.REACT_APP_ENV;
  // const store = currentEnv == "qa" ? sessionStorage : localStorage;
  const store = localStorage;

  React.useEffect(() => {
    // getCommonFeatureRetail();
    localStorage.setItem("showRetail", true);
    getCommonEditCredit();
  }, []);

  // const getCommonFeatureRetail = async () => {
  //   let payload = {
  //     shortName: "NBA_RETAIL_BOOKING",
  //     audiences: [
  //       {
  //         type: "cpid",
  //         values: [
  //           JSON.stringify(JSON.parse(localStorage.getItem("userinfo"))?.spId),
  //         ],
  //       },
  //     ],
  //   };
  //   let res = await API.Api(SHOW_RETAILBY_ID).post(payload);
  //   if (res?.status) {
  //     let data = res?.response?.data?.data;
  //     if (data?.success) {
  //       localStorage.setItem("showRetail", data?.success);
  //     } else {
  //       localStorage.setItem("showRetail", false);
  //     }
  //   } else {
  //     localStorage.setItem("showRetail", false);
  //   }
  // };

  const getCommonEditCredit = async () => {
    let currentState = JSON.parse(store.getItem("userinfo"))?.state;

    let payload = {
      shortName: "NBA_EDIT_BOOKING",
      audiences: [
        {
          type: "cpid",
          values: [JSON.stringify(JSON.parse(store.getItem("userinfo"))?.spId)],
        },
        // {
        //   type: "state",
        //   values: [currentState],
        // },
      ],
    };

    let url;
    if (currentEnv == "qa") {
      url = SHOW_RETAIL_ID_QA;
    } else {
      url = SHOW_RETAIL_ID_PROD;
    }

    let res = await API.Api(url).post(payload);

    if (res?.status) {
      let data = res?.response?.data?.data;

      if (data?.success) {
        localStorage.setItem("editCredit", data?.success);
      } else {
        localStorage.setItem("editCredit", false);
      }
    } else {
      localStorage.setItem("editCredit", false);
    }
  };

  const getCommonFeatureRetail = async () => {
    let currentState = JSON.parse(store.getItem("userinfo"))?.state;

    let payload = {
      shortName: "NBA_RETAIL_BOOKING",
      audiences: [
        {
          type: "cpid",
          values: [JSON.stringify(JSON.parse(store.getItem("userinfo"))?.spId)],
        },
        {
          type: "state",
          values: [currentState],
        },
      ],
    };

    let url;
    if (currentEnv == "qa") {
      url = SHOW_RETAIL_ID_QA;
    } else {
      url = SHOW_RETAIL_ID_PROD;
    }

    let res = await API.Api(url).post(payload);

    if (res?.status) {
      let data = res?.response?.data?.data;

      if (data?.success) {
        localStorage.setItem("showRetail", data?.success);
      } else {
        localStorage.setItem("showRetail", false);
      }
    } else {
      localStorage.setItem("showRetail", false);
    }
  };

  return (
    <>
      <div className="login-container-headding">Please select your company</div>
      <Form autoComplete="on" onFinish={handleRedirectDashboard}>
        <div className="login-container-email" style={{ marginTop: 20 }}>
          Company name
        </div>
        <Form.Item
          name="travelBy"
          rules={[
            {
              required: true,
              message: "Select  value",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select company"
            onSelect={(e, l) => setSelectedCompany(l)}
            defaultOpen
            notFoundContent={
              loading ? (
                <Spin
                  size="small"
                  style={{ display: "flex", justifyContent: "center" }}
                />
              ) : null
            }
            options={loading ? null : companies || []}
          />
        </Form.Item>
        <Form.Item>
          <div className="login-container-btndiv">
            <Button
              className="save-btn mt-2"
              size="large"
              htmlType="submit"
              block
            >
              CONTINUE
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default CompanySelection;
